import * as React from 'react';

export const BulletList: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M12.1464 4.47037H4.39368C4.03054 4.47037 3.73438 4.75104 3.73438 5.09437V5.17971C3.73438 5.52304 4.03054 5.80371 4.39368 5.80371H12.1464C12.5095 5.80371 12.8064 5.52304 12.8064 5.17971V5.09437C12.8064 4.75104 12.5095 4.47037 12.1464 4.47037Z"
				fill="currentColor"
			/>
			<path
				d="M12.1464 8.60475H4.39368C4.03054 8.60475 3.73438 8.88542 3.73438 9.22875V9.31408C3.73438 9.65741 4.03054 9.93808 4.39368 9.93808H12.1464C12.5095 9.93808 12.8064 9.65741 12.8064 9.31408V9.22875C12.8064 8.88542 12.5095 8.60475 12.1464 8.60475Z"
				fill="currentColor"
			/>
			<path
				d="M12.1464 0.336H4.39368C4.03054 0.336 3.73438 0.616667 3.73438 0.96V1.04533C3.73438 1.38867 4.03054 1.66933 4.39368 1.66933H12.1464C12.5095 1.66933 12.8064 1.38867 12.8064 1.04533V0.96C12.8064 0.616667 12.5095 0.336 12.1464 0.336Z"
				fill="currentColor"
			/>
			<path d="M1 0C0.448 0 0 0.448 0 1C0 1.552 0.448 2 1 2C1.552 2 2 1.552 2 1C2 0.448 1.552 0 1 0Z" fill="currentColor" />
			<path
				d="M1 8.27194C0.448 8.27194 0 8.71994 0 9.27194C0 9.82394 0.448 10.2719 1 10.2719C1.552 10.2719 2 9.82394 2 9.27194C2 8.71994 1.552 8.27194 1 8.27194Z"
				fill="currentColor"
			/>
			<path
				d="M1 3.93594C0.448 3.93594 0 4.38394 0 4.93594C0 5.48794 0.448 5.93594 1 5.93594C1.552 5.93594 2 5.48794 2 4.93594C2 4.38394 1.552 3.93594 1 3.93594Z"
				fill="currentColor"
			/>
		</svg>
	);
};
